/*----------------Libraries-----------------*/
import Snackbar from "@mui/material/Snackbar";
import Fade from "@mui/material/Fade";
import { observer } from "mobx-react-lite";
import { Alert } from "@mui/material";

/*----------------Store--------------------*/
import { useStore } from "../../stores/store";

export default observer(function Index() {
  const { toasterStore } = useStore();
  const { toast, closeToaster } = toasterStore;

  const handleClose = () => {
    closeToaster();
  };

  return (
    <div>
      {toast.open && (
        <Snackbar
          open={toast.open}
          slots={{ transition: Fade }}
          autoHideDuration={3000}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            position: "fixed",
            zIndex: 9999,
            top: { xs: "auto", md: 24 },
            bottom: { xs: 120, md: "auto" },
            left: { xs: "50%", md: "auto" },
            right: { xs: "auto", md: 24 },
            transform: { xs: "translateX(-50%)", md: "none" },
            width: { xs: "calc(100% - 32px)", md: "auto" },
            maxWidth: { xs: "90%", md: "400px" },
          }}
        >
          <Alert
            onClose={handleClose}
            severity={toast.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
});
